import React from 'react';
import { FieldType } from '../../types/Form';

export interface FieldTypeOption {
  type: FieldType;
  label: string;
  icon: string;
  predefined?: boolean;
}

const FIELD_TYPES: FieldTypeOption[] = [
  { type: 'text', label: 'Text Input', icon: '📝' },
  { type: 'date', label: 'Date', icon: '📅' },
  { type: 'select', label: 'Dropdown', icon: '📋' },
  { type: 'radio', label: 'Radio Buttons', icon: '⚫' },
  { type: 'checkbox', label: 'Checkboxes', icon: '☑️' },
  { type: 'textarea', label: 'Text Area', icon: '📄' },
  { type: 'number', label: 'Number', icon: '🔢' },
  { type: 'tel', label: 'Phone', icon: '📱' },
  { type: 'email', label: 'Email', icon: '📧' },
  { type: 'url', label: 'Website URL', icon: '🌐' },
  { type: 'file', label: 'File Upload', icon: '📎' },
  { type: 'multiselect', label: 'Multi-Select', icon: '☑️' }
];

interface FormBuilderFieldLibraryProps {
  onAddField: (fieldType: FieldTypeOption) => void;
  fieldCount: number;
  maxFields: number;
}

/**
 * Left-panel field library: list of field types to add to the form.
 */
const FormBuilderFieldLibrary: React.FC<FormBuilderFieldLibraryProps> = ({
  onAddField,
  fieldCount,
  maxFields
}) => (
  <div>
    <h4 className="font-medium mb-2">Add Fields ({fieldCount}/{maxFields})</h4>
    <div className="space-y-2">
      {FIELD_TYPES.map((fieldType) => (
        <button
          key={fieldType.type + fieldType.label}
          onClick={() => onAddField(fieldType)}
          disabled={fieldCount >= maxFields}
          className="w-full text-left px-3 py-2 border border-gray-200 rounded-md flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors hover:bg-gray-50 hover:border-gray-300"
          aria-label={`Add ${fieldType.label}`}
        >
          <span>{fieldType.icon}</span>
          <span className="text-sm">{fieldType.label}</span>
        </button>
      ))}
    </div>
  </div>
);

export default FormBuilderFieldLibrary;
export { FIELD_TYPES };
